import { type Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { type Opportunity } from './Opportunity'
import {
  type OpportunityEvent,
  type OpportunityUpdatedEvent,
} from './opportunity-events'

/**
 * Using an input observable of opportunity updates,
 * emits when an opportunity we haven't loaded by querying becomes available.
 */
export function filterIncomingOpportunities() {
  return (input$: Observable<OpportunityEvent>): Observable<Opportunity> =>
    input$.pipe(
      filter(
        (e): e is OpportunityUpdatedEvent =>
          e.type === 'OpportunityUpdated' && e.becameAvailable,
      ),
      map((e) => e.opportunity),
    )
}
